(function () {
  "use strict";

  mfCompositeSearchInput.$inject = ['$timeout', 'compositeSearchData'];
  angular
    .module('trainerWebApp.directives')
    .directive('mfCompositeSearchInput', mfCompositeSearchInput);

  function mfCompositeSearchInput($timeout, compositeSearchData) {
    return {
      restrict: 'A',
      link: function ($scope, iElement, iAttrs) {
        var select = iElement.find("#searchTraineeComposite");

        select.select2($scope.selectOptions);

        var searchItem = compositeSearchData.getSearchItem();

        if (searchItem) {
          compositeSearchData.clearSearchItem();
          select.select2('data', searchItem);
          var searchInput = iElement.find('.select2-input');
          searchInput.removeClass("select2-default");
        }

        $scope.clearSearch = function () {
          select.select2("data", []);
          $scope.applyEmptyFilter();
          setPlaceholder($scope.placeholder);
        };

        select.bind('change', function (event) {
          var selectedItems = select.select2('data');

          $scope.$apply(function () {
            $scope.searchChanged(selectedItems);
          })
        });

        $scope.$on('clearSearchRequested', $scope.clearSearch);

        select.bind("select2-selecting", function (event) {
          if (event.object.children) {
            event.preventDefault();
            $scope.secondLevelMenuName = event.object.name;
            var searchInput = iElement.find('.select2-input');
            var term = searchInput.val();
            select.select2('close');
            searchInput.val(term);
            searchInput.removeClass("select2-default");
            select.select2('open');
          } else {
            event.object.track();
          }
        });

        select.bind('select2-open', function (event) {
          $('.select2-dropdown-size-hack').removeClass('select2-dropdown-size-hack');
        });

        select.bind('select2-blur', function (event) {
          setPlaceholder($scope.placeholder);
        });

        $scope.$on('setPlaceholder', function (event, val) {
          setPlaceholder(val || $scope.placeholder);
        });

        $scope.$on('clearSearch', function () {
          $scope.clearSearch();
        });

        $scope.$on('doSearch', function (event, items) {

          select.select2('data', items);

          $scope.searchChanged(items);
        });

        $scope.$watch('sidebarContentSrc', function (newValue) {
          setPlaceholder(newValue ? $scope.openSidebarPlaceholder : $scope.overridePlaceholder);
        });

        function setPlaceholder(val) {
          iElement.find('.select2-input.select2-default').val(val);
          $scope.placeholder = val;
        }

        $scope.getSelectedItems = function () {
          return select.select2('data');
        };

        $scope.$on('resizeSearch', function () {
          // Crazy hack to make search resizes without modifying select2. Open and close select2 and then blur
          // the focus from the text box.
          select.select2('open');
          select.select2('close');

          $timeout(function () {
            // DOM need to update before we can blur it.
            iElement.find('.select2-input.select2-focused').blur();
          }, 1);
        });

        $scope.$on("refreshSearch", function () {
          var selectedItems = select.select2('data');
          _.each(selectedItems, function (item) {
            item.filter = null;
          });
          $scope.searchChanged(selectedItems);
        });

        $scope.$on('removeLastFilter', function (e, cb) {
          var selectedItems = select.select2('data').slice(0, -1);
          select.select2('data', selectedItems);
          $scope.searchChanged(selectedItems);
          if (cb) cb();
        });
      }
    }
  }

})();
